export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./success.vue?vue&type=template&id=08720bee&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/success.vue?vue&type=template&id=08720bee&
// module id = 1234
// module chunks = 0